import React from "react";
import { Card, Row, Col, CardImg, CardText } from "reactstrap";
import "./card-view.scss";
function shorText(cad) {
  if (cad != null) {
    if (cad.length > 170) {
      return cad.substring(0, 170) + " ...";
    }
  }
  return cad;
}
function shorTextCustom(cad,size) {
    if (cad != null) {
      if (cad.length > size) {
        return cad.substring(0, size) + " ...";
      }
    }
    return cad;
  }
function CardView(props) {
  if (props.items.length > 0) {
    return (
      <Row className="no-gutters ">
        {props.items.map((item, index) => (
          <Col key={index} xs={12} sm={12} md={4} xl={4} className="block-height">
            <Card className=" mt-1 ml-2 mr-2">
              <Row className="no-gutters mb-2 card-item-square">
                <Col xs={12} sm={12} md={12} xl={12} className="card-item-image"
                >
                  <CardImg
                    className=" img-thumbnail-view text-center"
                    src={`${item.url_caratula}`}
                    alt="Portada"
                  />
                  <div className="card-item-box">
                  <div className="ml-2 mt-4 text-left">
                    <div className="ml-2 mr-5">
                      <span>
                        <a
                          href={`${item.url_sinia}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          title={item.nombre}
                        >
                          <p className="block-text-title font-weight-bold">
                            {shorTextCustom(item.nombre,113)}
                          </p>
                        </a>
                      </span>
                    </div>
                    <div className="ml-2">
                      <span className="card-item-tipo">{item.tipo}</span>
                    </div>
                    <div className="ml-2">
                      <CardText className="mt-2 card-item-link">
                      <a
                          href={`${item.url_sinia}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          title={item.nombre}
                        >
                          <i className="fas fa-angle-right i-fas"></i>
                        </a>
                      </CardText>
                    </div>
                  </div>
                    </div>
                </Col>
              </Row>
            </Card>
          </Col>
        ))}
      </Row>
    );
  } else {
    return <div></div>;
  }
}

export default CardView;
